import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_h6g94fjyyp: FaireCollectionEntity = {
  token: "pbc_h6g94fjyyp",
  type: "collection",
  name: "FOR DOG LOVERS",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b9dc03b9f50855caff41ac735a4887f41a44b5c801f733cadd6765b06da9ef8b.jpeg",
  itemCount: 27,
  brandToken: "b_q8gu9by5sv",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:48:54.406Z",
    importedBy: "entity-db-import-collections",
  },
};
